// ============================================
// VOLUNTEER MODULE - THEME CONTEXT
// Light and Dark mode
// ============================================

import React, { createContext, useContext, useState } from "react";

// ── DARK THEME ─────────────────────────────
export const DARK = {
  bg:          "#0A0E1A",
  card:        "#1A2235",
  surface:     "#111827",
  border:      "#1E2D45",
  accent:      "#00D4FF",
  accentSoft:  "#00D4FF22",
  green:       "#00E5A0",
  greenSoft:   "#00E5A022",
  orange:      "#FF8C42",
  orangeSoft:  "#FF8C4222",
  red:         "#FF4D6D",
  redSoft:     "#FF4D6D22",
  purple:      "#9B8FFF",
  purpleSoft:  "#9B8FFF22",
  text:        "#E8EDF5",
  muted:       "#6B7A99",
  dim:         "#3D4F6E",
  navBg:       "#111827",
  inputBg:     "#0A0E1A",
  modalBg:     "#000000bb",
  shadow:      "0 4px 24px rgba(0,0,0,0.4)",
};

// ── LIGHT THEME ────────────────────────────
export const LIGHT = {
  bg:          "#F0F4F8",
  card:        "#FFFFFF",
  surface:     "#F7FAFC",
  border:      "#E2E8F0",
  accent:      "#0284C7",
  accentSoft:  "#0284C715",
  green:       "#059669",
  greenSoft:   "#05966915",
  orange:      "#D97706",
  orangeSoft:  "#D9770615",
  red:         "#DC2626",
  redSoft:     "#DC262615",
  purple:      "#7C3AED",
  purpleSoft:  "#7C3AED15",
  text:        "#1A202C",
  muted:       "#64748B",
  dim:         "#94A3B8",
  navBg:       "#FFFFFF",
  inputBg:     "#F8FAFC",
  modalBg:     "#00000066",
  shadow:      "0 4px 24px rgba(0,0,0,0.1)",
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  // Default theme is light; remember user's choice across sessions
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem("vh_theme");
      if(saved === "dark") return true;
      if(saved === "light") return false;
    } catch {}
    return false; // default = light
  });
  const C = isDark ? DARK : LIGHT;
  const toggleTheme = () => setIsDark(d => {
    const next = !d;
    try { localStorage.setItem("vh_theme", next ? "dark" : "light"); } catch {}
    return next;
  });

  return (
    <ThemeContext.Provider value={{ C, isDark, toggleTheme }}>
      <div style={{ background: C.bg, minHeight: "100vh", transition: "background 0.3s, color 0.3s", color: C.text }}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}